import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SummaryPlay from '../SummaryPlay';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import play from '../store/reducers/play';
import { getPlayState } from '../store/selectors/getPlayState';

initContainerData.register({
    reducers: { play }
});

const SummaryPlayDataContainer = ({
    dataIndex,
    filters,
    openAtBatOverlay,
    displayParallaxAd,
    ...otherProps
}) => {
    const {
        playData = {},
        teams = {},
        playVideoMap = {},
        isLoading,
        deviceInteraction,
        playMetrics,
        language
    } = useSelector(getPlayState(dataIndex));

    const {
        resultPlayGuid,
        about: {
            isComplete = false
        } = {}
    } = playData;

    return (isComplete
        ? <SummaryPlay
            { ...otherProps }
            filters={ filters }
            playData={ playData }
            resultVideo={ playVideoMap[resultPlayGuid] }
            teams={ teams }
            isLoading={ isLoading }
            deviceInteraction={ deviceInteraction }
            openAtBatOverlay={ openAtBatOverlay }
            playMetrics={ playMetrics }
            displayParallaxAd={ displayParallaxAd }
            language={ language }
        />
        : null
    );
};

SummaryPlayDataContainer.propTypes = {
    dataIndex: PropTypes.number,
    filters: PropTypes.object,
    displayParallaxAd: PropTypes.bool
};

export default SummaryPlayDataContainer;
